import { indexOf } from 'lodash'
import { Toast, ADD_TOAST_MESSAGE } from 'vuex-toast'
import { uuid } from 'vue-uuid'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Vlibras, CustomNotification } from '@/components'
import localforageKeys from '@/helper/localForageKeys'

export default {
  data () {
    return {
      allActiveTabs: []
    }
  },
  components: {
    Toast,
    CustomNotification,
    Vlibras
  },
  computed: {
    ...mapGetters([
      'getterSettingWebchat',
      'getterIsSacContext',
      'getterSelectedBot',
      '$getterVlibras'
    ]),

    enableVlibras () {
      return Object.keys(this.$getterVlibras).length > 0 && Object.prototype.hasOwnProperty.call(this.$getterVlibras, 'enabled') && this.$getterVlibras.enabled
    }
  },
  sockets: {
    error () {
      this.addToastMessage({
        text: 'Erro ao enviar mensagem, por favor tente novamente mais tarde!',
        type: 'danger',
        dismissAfter: 6000
      })

      this.SET_GENERIC_EVENTS({
        key: 'IsWritingLoading',
        value: false
      })
    },
    unauthorized () {
      this.addToastMessage({
        text: 'Você não está autorizado a acessar este bot, por favor entre em contato com o suporte!',
        type: 'danger',
        dismissAfter: 60000
      })
    }
  },
  mounted () {
    this.$actionSystemView('bot')
    this.$actionConfigChatFile({ validFormats: [], sizeMax: '4194304' })
    this.handlerDestroyApp()
    this.CLEAR_SOCKETIO_STORE()

    window.addEventListener('beforeunload', this.handlerDestroyApp)

    this.$eventBus.$on('ServiceWorkerUpdated', () => {
      this.SET_AVAILABLE_UPDATE(true)
      let text = ''
      if (this.isDesktop) {
        text = 'Clique em Atualizar.'
      } else {
        text = 'Aperte em Atualizar.'
      }
      this.$notify({
        group: 'custom-notifier',
        type: 'success',
        title: 'Novo conteúdo disponível!',
        text,
        duration: 20000
      })
    })
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlerDestroyApp)

    this.$eventBus.$off('ServiceWorkerUpdated')
  },
  methods: {
    ...mapActions([
      'cleanStorage',
      'actionEmitMessage',
      'actionRemoveLocalForageListTabs',
      '$actionConfigChatFile',
      '$actionSystemView'
    ]),
    ...mapMutations([
      'CLEAR_SOCKETIO_STORE',
      'SET_AVAILABLE_UPDATE',
      'SET_GENERIC_EVENTS'
    ]),
    ...mapActions({
      addToastMessage: ADD_TOAST_MESSAGE
    }),
    async removeLocalForageActualIndexTab () {
      const response = JSON.parse(localStorage.getItem(localforageKeys.ACTIVE_TABS('localforage/')) || '[]')

      const index = indexOf(response, this.$route.query.activeTab)

      if (index > -1) {
        response.splice(index, 1)
      }

      this.$setItem('peoplechat-activeTabs', response)
    },
    handlerDestroyApp () {
      // this.removeLocalForageActualIndexTab()

      this.actionEmitMessage({
        id: uuid.v4(),
        channelId: 'peoplechat',
        type: 'message',
        botId: this.getterSettingWebchat.botId,
        userId: this.getterSettingWebchat.userId,
        username: this.getterSettingWebchat.username,
        conversationId: this.getterSettingWebchat.conversationId,
        message: 'endOfConversation',
        event: 'endOfConversation'
      })

      this.deleteAllCookies()

      this.cleanStorage()

      sessionStorage.setItem('firstBoot', JSON.stringify(true))
    },
    deleteAllCookies () {
      const cookies = document.cookie.split(';')

      cookies.forEach((item) => {
        const cookie = item
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
      })
    }
  }
}
